// LinkedIn and GitHub validation helpers (for Jest testing)

const validateLinkedIn = (url) => {
  const regex = /^https?:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
  return regex.test(url);
};

const validateGitHub = async (url) => {
  const regex = /^https?:\/\/(www\.)?github\.com\/[a-zA-Z0-9_-]+\/?$/;
  if (!regex.test(url)) return false;

  const match = url.match(/github\.com\/([a-zA-Z0-9_-]+)/);
  if (!match) return false;

  const username = match[1];
  try {
    const response = await fetch(`https://api.github.com/users/${username}`);
    return response.ok;
  } catch (error) {
    return false;
  }
};

module.exports = { validateLinkedIn, validateGitHub };
